import React from 'react';
import Sidebar from './Sidebar';

const MainLayout = ({ children }) => {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar (fixed) */}
      <div style={{ width: '250px', flexShrink: 0, height: '100vh' }}>
        <Sidebar />
      </div>

      {/* Main content scrolls */}
      <div style={{ flexGrow: 1, overflowY: 'auto', padding: '20px' }}>
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
